import { Component, Input, OnInit } from "@angular/core"
import { Award } from "src/app/models"
import { EmployeeService } from "src/app/services"
import { NgClass, DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { VirtualListBoxComponent } from "../virtual-listbox/virtual-listbox.component";
import { PositionsNamesPipe } from "../../pipes/positions-names.pipe";
import { ObjectKeysPipe } from "../../pipes/object-keys.pipe";
import { OrgUnitsNamesPipe } from "../../pipes/orgUnits-names.pipe";
import { CostCenterNamesPipe } from "../../pipes/cost-center-names.pipe";
import { ContractNamesPipe } from "../../pipes/contract-names.pipe";
import { StripHtmlPipe } from "../../pipes/strip-html.pipe"
import { CategoryNamesPipe } from "../../pipes/category-names.pipe"
import { MatIcon } from "@angular/material/icon"

@Component({
    selector: "valben-awards-history",
    templateUrl: "./awards-history.component.html",
    styles: [`
        b {
            white-space: nowrap;
        }
    `],
    standalone: true,
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIcon,
        NgClass,
        VirtualListBoxComponent,
        DatePipe,
        PositionsNamesPipe,
        ObjectKeysPipe,
        OrgUnitsNamesPipe,
        CostCenterNamesPipe,
        ContractNamesPipe,
        StripHtmlPipe,
        CategoryNamesPipe,
    ],
})

export class AwardsHistoryComponent implements OnInit {
    @Input() values: Award[] = []
    nameLangs: string[] = []
    descLangs: string[] = []
    showDepends: boolean[][] = []
    included: string[][] = []
    excluded: string[][] = []

    constructor(private _empService: EmployeeService) {}

    toggle(i: number, j: number): void {
        this.showDepends[i][j] = !this.showDepends[i][j]

        if (j !== 2 && this.showDepends[i][j]) {
            this._empService.GetEmployeesNames(
                this.values[i].dependencies.includedEmployees || [],
                this.values[i].dependencies.excludedEmployees || [],
            ).subscribe(res => {
                this.included[i] = res.filter(x => x.included).map(x => x.mbradName)
                this.excluded[i] = res.filter(x => !x.included).map(x => x.mbradName)
            })
        }
    }

    ngOnInit(): void {
        this.nameLangs = this.values.map(_ => "hr")
        this.descLangs = this.values.map(_ => "hr")
        this.showDepends = this.values.map(_ => [false, false, false])
        this.included = this.values.map(_ => [])
        this.excluded = this.values.map(_ => [])
    }
}

